import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { EmailTemplateInfosManagement } from '../components/EmailTemplateInfosManagement';
import { useNavigate } from 'react-router-dom';
import {
  TEmailTemplateSchema,
  emailTemplateSchema,
} from '@/schemas/email-template/email-template.schema';
import { useCreateEmailTemplate } from '@/hooks/email-template.hooks';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '@/utils/language.utils';

export const CreateEmailTemplatePage = () => {
  const { t } = useTranslation('emailTemplate');
  const navigate = useNavigate();

  const {
    watch: watchEmailTemplate,
    control: emailTemplateControl,
    register: registerEmailTemplate,
    setValue: setEmailTemplateValue,
    setError: setEmailTemplateError,
    handleSubmit: handleSubmitEmailTemplate,
    formState: {
      errors: emailTemplateErrors,
      isSubmitting: isSubmittingEmailTemplate,
    },
  } = useForm<TEmailTemplateSchema>({
    resolver: zodResolver(emailTemplateSchema),
  });

  const {
    mutate: mutateCreateEmailTemplate,
    isPending: isPendingCreateEmailTemplate,
  } = useCreateEmailTemplate({
    t,
    handleSuccess: () => navigate('/email-templates'),
  });

  const onSubmitEmailTemplate = (emailTemplate: TEmailTemplateSchema) => {
    const { languageCode } = getLanguage();

    const dataWithLanguageCode = {
      ...emailTemplate,
      languageCode,
    };

    mutateCreateEmailTemplate(dataWithLanguageCode);
  };

  return (
    <>
      <PageHeader
        backToLink="/email-templates"
        title={t('brevoEmailTemplate')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem
              text={t('emailTemplateList')}
              linkTo="/email-templates"
            />
            <BreadcrumbItem text={t('brevoEmailTemplate')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <EmailTemplateInfosManagement<TEmailTemplateSchema>
          t={t}
          watch={watchEmailTemplate}
          control={emailTemplateControl}
          register={registerEmailTemplate}
          setValue={setEmailTemplateValue}
          setError={setEmailTemplateError}
          errors={emailTemplateErrors}
          submitDisabled={
            isSubmittingEmailTemplate || isPendingCreateEmailTemplate
          }
          onSubmit={handleSubmitEmailTemplate(onSubmitEmailTemplate)}
        />
      </div>
    </>
  );
};
